import  React,  { Component } from 'react';
import { MorphReplaceResize } from 'react-svg-morph';

const styleObj = {
    fontFamily: 'Monoton',
    fontSize: 44,
    backgroundColor:'#FFD700',
    color: '#40E0D0'
}

class SoccerBall extends Component {
    render() {
        return (
            <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
            style={{ height: 512, width: 512 }}
          >
            <path d="M0 0h512v512H0z"></path>
            <path
              fill="#fff"
              d="M255.03 33.813a229.242 229.242 0 00-5.5.03c-6.73.14-13.462.605-20.155 1.344.333.166.544.32.47.438L204.78 75.063l73.907 49.437-.125.188 70.625.28L371 79.282 342.844 52a225.62 225.62 0 00-49.47-14.78c-12.65-2.24-25.497-3.36-38.343-3.407zM190.907 88.25l-73.656 36.78-13.813 98.407 51.344 33.657 94.345-43.438 14.875-76.5-73.094-48.906zm196.344.344l-21.25 44.5 36.75 72.72 62.063 38.905 11.312-21.282c.225.143.45.403.656.75-.77-4.954-1.71-9.893-2.81-14.782-6.446-28.59-18.59-55.962-35.5-79.97-9.07-12.872-19.526-24.778-31.095-35.5l-20.125-5.342zm-302.656 23c-6.906 8.045-13.257 16.56-18.938 25.5-15.676 24.664-26.44 52.494-31.437 81.312A223.087 223.087 0 0031 261l20.25 5.094 33.03-40.5L98.75 122.53l-14.156-10.936zm312.719 112.844l-55.813 44.75-3.47 101.093 39.626 21.126 77.188-49.594 4.406-78.75-.094.157-61.844-38.783zm-140.844 6.406l-94.033 43.312-1.218 76.625 89.155 57.376 68.938-36.437 3.437-101.75-66.28-39.126zm-224.22 49.75c.91 8.436 2.29 16.816 4.156 25.094 6.445 28.59 18.62 55.96 35.532 79.968 3.873 5.5 8.02 10.805 12.374 15.938l-9.374-48.156.124-.032-27.03-68.844-15.782-3.968zm117.188 84.844l-51.532 8.156 10.125 52.094a225.067 225.067 0 0027.314 20.437 226.31 226.31 0 0046.687 22.594l62.626-13.69-4.344-31.124-90.875-58.47zm302.437.5l-64.22 41.25-42 47.375 4.408 6.156c12.027-5.545 23.57-12.144 34.406-19.72 23.97-16.76 44.604-38.304 60.28-62.97 2.51-3.947 4.87-7.99 7.125-12.092zm-122.78 97.656l-79.94 9.625-25.968 5.655c26.993 4 54.717 3.044 81.313-2.813 9.412-2.072 18.684-4.79 27.75-8.062l-3.156-4.406z"
            ></path>
          </svg>
        );
    }
}

class SoccerField extends Component {
    render() {
        return (
            <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
            style={{ height: 512, width: 512 }}
          >
            <path d="M0 0h512v512H0z"></path>
            <path
              fill="#fff"
              d="M23 119v274h466V119H23zm18 18h206v79.016c-18.25 4.135-32 20.537-32 39.984 0 19.447 13.75 35.85 32 39.984V375H41v-62h64V199H41v-62zm224 0h206v62h-64v114h64v62H265v-79.016c18.25-4.135 32-20.537 32-39.984 0-19.447-13.75-35.85-32-39.984V137zM41 217h46v78H41v-78zm384 0h46v78h-46v-78zm-178 17.793v42.414c-8.27-3.467-14-11.6-14-21.207 0-9.606 5.73-17.74 14-21.207zm18 0c8.27 3.467 14 11.6 14 21.207 0 9.606-5.73 17.74-14 21.207v-42.414z"
            ></path>
          </svg>
        );
    }
}

class Hello extends Component{
constructor(props) {
    super(props);
    this.increment = 0;
    this.swap();
}
swap() {
    setInterval(() => {
        this.increment++
        this.forceUpdate();
    }, 1500)
}
render() {
    var icon = this.increment % 2 === 1 ? <SoccerBall key="logo" /> : <SoccerField fill="#FF0000" key="heart" />;
    return (
        <div>
        <div style={styleObj}>Hi, I'm Harrison. 
        <MorphReplaceResize width={50} height={50}>
            {icon}
        </MorphReplaceResize>
        I am a Front End Developer, and I love to build beautiful, functional websites.</div>
        </div>
    );
}
}




export default Hello; 